import React from "react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Upload, X, FileText, Image, Shield } from "lucide-react";
import { Controller, useFormContext } from "react-hook-form";

interface FileUploadFormProps {
  files: File[];
  onDragOver: (e: React.DragEvent) => void;
  onDragLeave: (e: React.DragEvent) => void;
  onDrop: (e: React.DragEvent) => void;
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onRemoveFile: (index: number) => void;
}

export const FileUploadForm = ({
  files,
  onDragOver,
  onDragLeave,
  onDrop,
  onFileChange,
  onRemoveFile,
}: FileUploadFormProps) => {
  const { control, formState: { errors } } = useFormContext();

  return (
    <div className="space-y-6">
      {/* <div
        onDragOver={onDragOver}
        onDragLeave={onDragLeave}
        onDrop={onDrop}
        className="border-2 border-dashed border-blue-200 rounded-lg p-8 text-center transition-colors hover:border-emerald-500"
      >
        <Upload className="w-12 h-12 mx-auto text-sky-500 mb-4" />
        <p className="text-gray-600 mb-2">
          Drag and drop your files here, or{" "}
          <label className="text-emerald-600 cursor-pointer hover:text-emerald-700 underline">
            browse
            <input
              type="file"
              className="hidden"
              multiple
              onChange={onFileChange}
            />
          </label>
        </p>
        <p className="text-sm text-gray-500">
          Supported files: PDF, DOC, DOCX, PNG, JPG (max 10MB each)
        </p>
      </div>

      <div className="space-y-2">
        {files.length > 0 && (
          <Label className="block text-sm font-medium text-gray-700 mb-2">
            Uploaded Files
          </Label>
        )}
        {files.map((file, index) => (
          <div
            key={index}
            className="flex items-center justify-between p-3 bg-gradient-to-r from-sky-50 to-emerald-50 rounded-lg"
          >
            <div className="flex items-center">
              {file.type.includes("image") ? (
                <Image className="w-4 h-4 text-sky-600 mr-2" />
              ) : (
                <FileText className="w-4 h-4 text-emerald-600 mr-2" />
              )}
              <span className="text-sm text-gray-600 truncate max-w-xs">{file.name}</span>
              <span className="text-xs text-gray-400 ml-2">
                {(file.size / 1024 / 1024).toFixed(2)} MB
              </span>
            </div>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onRemoveFile(index)}
              className="text-gray-500 hover:text-red-500"
            >
              <X className="w-4 h-4" />
            </Button>
          </div>
        ))}
      </div> */}

      <div className="space-y-2 pt-4 border-t border-gray-100">
        <div className="flex items-center">
          <Label htmlFor="projectVisibility" className="font-medium text-sm text-gray-700">
            Project Visibility
          </Label>
          <Shield className="h-4 w-4 ml-2 text-sky-500" />
        </div>
        <Controller
          name="projectVisibility"
          control={control}
          render={({ field }) => (
            <Select
              value={field.value}
              onValueChange={field.onChange}
            >
              <SelectTrigger id="projectVisibility" className="border-blue-100 focus:border-emerald-300 focus:ring-1 focus:ring-emerald-300">
                <SelectValue placeholder="Select project visibility" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="public">Public - Visible to all freelancers</SelectItem>
                <SelectItem value="private">Private - Invite only</SelectItem>
              </SelectContent>
            </Select>
          )}
        />
        {errors.projectVisibility && (
          <p className="text-xs text-red-500">{errors.projectVisibility.message as string}</p>
        )}
        <p className="text-xs text-gray-500 mt-1">
          {useFormContext().watch("projectVisibility") === "public" &&
            "Your project will be visible to all freelancers on the platform."}
          {useFormContext().watch("projectVisibility") === "private" &&
            "Your project will only be visible to freelancers you invite."}
        </p>
      </div>
    </div>
  );
};